<template>
  <div>
    <v-dialog v-model="deleteProductDialog" scrollable persistent :overlay="false" max-width="600px" transition="dialog-transition">
      <template v-slot:activator="{ on }">
        <v-icon text small class="mr-4 " v-on="on">
          delete
        </v-icon>
      </template>

      <v-card>
        <v-container>
          <v-layout row wrap>
            <v-flex xs12>
              <div v-if="error">
                <app-alert-error class="mb-0" @dismissed="onDismiss" :text="error.message"></app-alert-error>
              </div>
              <v-card-title class="mx-3">
                <v-row>
                  <h4>
                    Delete product
                  </h4>
                  <v-spacer></v-spacer>
                  <v-icon class="font-weight-black" @click="deleteProductDialog = false">clear</v-icon>
                </v-row>
              </v-card-title>
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex xs12>
              <v-card-text text class=" red--text">
                <v-alert dense text type="error">
                  This will permanently delete all data associated with this product.
                </v-alert>
                <h4 class="black--text mt-5">
                  Are you sure you want to delete this product?
                </h4>
              </v-card-text>
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex xs12>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn depressed class="grey lighten-2" @click="deleteProductDialog = false">Cancel</v-btn>
                <v-btn depressed class="red white--text" @click="onConfirmDelete">Confirm</v-btn>
              </v-card-actions>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card>

    </v-dialog>
  </div>
</template>
<script>
import { store } from '@/store'
import { mapGetters } from 'vuex'

export default {
  props: ['product', 'supplierId'],
  data() {
    return {
      deleteProductDialog: false,
      isLoading: false
    }
  },
  computed: {
    ...mapGetters(['error'])
  },
  methods: {
    onDismiss() {
      store.commit('clearError')
    },
    onConfirmDelete() {
      this.isLoading = true
      /**
       * if request by admin, include supplierId
       */
      if (this.supplierId) {
        this.product.supplierId = this.supplierId
      }
      this.$store.dispatch('deleteProductFromSupplierProducts', this.product)
        .then((status) => {
          if (status === 'success') {
            this.deleteProductDialog = false
            this.isLoading = false
          } else {
            store.commit('setError', status)
          }
        })
        .catch(err => store.commit('setError', err))
    }
  }
}
</script>

<style scoped>
.v-icon.mdi-delete:hover {
  color: red;
}
</style>
